import {useEffect, useState} from "react";
import {getSound} from "../sounds";

import './EnsureAudio.css';
import {t} from "../i18n";
import canAutoplay from "can-autoplay";
import {DisplayConfig} from "./Config";

export default function EnsureAudio({config} : {
    config: DisplayConfig
}) {
    const [hasAudio, updateHasAudio] = useState(true)
    useEffect(() => {
        canAutoplay.audio().then(({result}) => {
            updateHasAudio(result);
        })
        const unmute = getSound('unmute')
        if(!unmute) {
            return;
        }
        unmute.on('unlock', () => {
            if(!config.mute) {
                unmute.play()
            }
            updateHasAudio(true)
        })
    }, []);

    // This forces browsers to consider the audio to always be playing
    // Since the buffer is a constant value, in practice it is just a very quiet
    // click when the sound starts/stops playing and no noise while it is playing
    useEffect(() => {
        if(config.mute || !hasAudio) {
            return;
        }

        const audioContext = new AudioContext();
        const noiseBuffer = audioContext.createBuffer(1, 1, audioContext.sampleRate);
        const output = noiseBuffer.getChannelData(0);
        output[0] = 0.01;

        const whiteNoise = audioContext.createBufferSource();
        whiteNoise.buffer = noiseBuffer;
        whiteNoise.loop = true;
        whiteNoise.start(0);

        whiteNoise.connect(audioContext.destination);
        return () => {
            audioContext.close()
        }
    }, [config.mute, hasAudio])

    return hasAudio || config.mute || config.type === "pit" || config.type === "sponsor" ? null : <div id="audioAlert">
        <h3>{t`Audio Warning`}</h3>
        <p>{t`This display is set to play sounds but currently cannot.`}<br/>{t`Click anywhere to unmute.`}</p>
        <button className={'btn btn-sm btn-light'}>{t`Unmute`}</button>
    </div>;
}